import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { get } from 'lodash';
import getPriceLabel from '@dashboard/services/translation/getPriceLabel';
import CardListItem from '@dashboard/components/CardListItem';
import TableRowElement from '@dashboard/components/TableRowElement';
import SubscriptionStatusBadge from '../SubscriptionStatusBadge/SubscriptionStatusBadge';
import isRecoveredAbandonment from '@/dashboard/services/abandonment/isRecoveredAbandonment';
import isAbandonedAbandonment from '@/dashboard/services/abandonment/isAbandonedAbandonment';
import { formatDateTime } from '@/dashboard/lib/format-date';
import Tooltip from '../Tooltip';
import StatusBadge from '../StatusBadge';
import Dash from '../Dash';

const propTypes = {
  subscription: PropTypes.object.isRequired,
};

const SubscriptionItem = ({ subscription, options = {} }) => {
  const livemode = get(subscription, 'livemode');
  const isCompact = options.appearance === 'compact';

  return (
    <CardListItem href={`/orders/subscriptions/${subscription._id}`}>
      {!options.hideCustomer && (
        <TableRowElement size={isCompact ? 'xl' : '3xl'} flexCol>
          <div className="font-medium">
            {get(subscription, 'customer.email') || get(subscription, 'customerEmail') || <Dash />}
          </div>
          <div className="text-sm text-gray-500">{get(subscription, 'customer.name')}</div>
        </TableRowElement>
      )}

      <TableRowElement size={isCompact ? 'large' : 'xl'} className="font-medium">
        {getPriceLabel({
          amount: subscription.amount,
          currency: subscription.currency,
          interval: subscription.interval,
          intervalCount: subscription.intervalCount,
          type: 'subscription',
        })}
      </TableRowElement>

      {!options.hidePaymentLink && (
        <TableRowElement size={isCompact ? 'xl' : '4xl'}>
          {get(subscription, 'page.name', <Dash />)}
        </TableRowElement>
      )}

      <TableRowElement size="xl" align="right">
        {format(new Date(get(subscription, 'createdAt')), 'd MMM, yyyy, HH:mm')}
      </TableRowElement>

      <TableRowElement size="large">
        {(() => {
          const isRecovered = isRecoveredAbandonment(subscription);
          const isAbandoned = isAbandonedAbandonment(subscription);

          if (isRecovered) {
            return (
              <Tooltip label={`Recovered on ${formatDateTime(subscription.recoveredAt)}`}>
                <StatusBadge status="recovered" label="Recovered" withInfoIcon />
              </Tooltip>
            );
          }

          if (isAbandoned) {
            return <SubscriptionStatusBadge status="abandoned" livemode={livemode} />;
          }

          return <>-</>;
        })()}
      </TableRowElement>

      {!options.hideStatus && (
        <>
          {(() => {
            return (
              <TableRowElement size="medium">
                <SubscriptionStatusBadge
                  status={subscription.status}
                  livemode={livemode}
                  error={subscription.paymentError}
                />
              </TableRowElement>
            );
          })()}
        </>
      )}
    </CardListItem>
  );
};

SubscriptionItem.propTypes = propTypes;

export default SubscriptionItem;
